import Toolbar from './toolbar';
import ToolbarButton from './toolbar-button';
import ToolbarLoadButton from './toolbar-load-button';
import ToolbarSaveButton from './toolbar-save-button';

export { Toolbar, ToolbarButton, ToolbarLoadButton, ToolbarSaveButton };

export default {
  ToolbarButton,
  ToolbarSaveButton,
  ToolbarLoadButton,
  Toolbar
};
